import axios from 'axios';
import {jwtDecode} from 'jwt-decode'; // Correctly import jwt-decode

const axiosInstance = axios.create({
    baseURL: 'http://localhost:8082', // Set your base URL here
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});


// Check if the token is expired
const checkTokenExpiry = () => {
    const token = localStorage.getItem('authToken');
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            const expiry = new Date(decodedToken.exp * 1000);
            if (expiry < new Date()) {
                localStorage.removeItem('authToken');
                window.location.href = '/login';
                return false;
            }
        } catch (e) {
            // Handle error if the token is invalid
            localStorage.removeItem('authToken');
            window.location.href = '/login';
            return false;
        }
    }
    return true;
};

// Request interceptor
axiosInstance.interceptors.request.use(
    config => {
        // Only attach token if the request URL is not for login or other public routes
        
            if (checkTokenExpiry()) {
                const token = localStorage.getItem('authToken');
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            } else {
                // Prevent the request from being sent if the token is expired
                return Promise.reject(new Error('Token expired'));
            }
        
        return config;
    },
    error => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Token expired or unauthorized
            alert('Session expired. Please log in again.');
            localStorage.removeItem('jwtToken');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);


export default axiosInstance;
